import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
//const baseURL = 'http://192.168.0.16/canoeServices/public/api/auth';
//const baseURL = 'http://piraguillarestservice.habanacompostela.com/api/auth';
//const baseURL = 'http://canoerestservice2.habanacompostela.com/api/auth';
//const baseURL = 'https://alvapy.com/canoeServices/public/api/auth';

const baseURL = 'https://piraguillarestservices.alvapy.com/api/auth';
//canoerestservices.alvapy.com	




axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);

